class B1G2Offer {
    constructor() {
        this.all_offer_products = document.querySelectorAll('.offer-products-list-item');
        this.selectedProducts = [];
        this.single_selected_product_container = document.querySelectorAll('.single-selected-product');
        this.add_to_cart_button = document.querySelector('.select-products-button');
        this.priceContainer = document.querySelector('.selected-products-info p');
        this.totalPrice = [];
        this.newSetNotice = document.querySelector('.new-set-notice');

        this.miniCart = document.querySelector('mini-cart');

        // document.addEventListener('cart:updated', () => this.init());
        // document.addEventListener('ajaxProduct:added', () => this.init());
    }

    async init() {
        this.cart = await this.getCart();

        this.disableProducts();
        this.selectProducts();
        this.ctaButtonClickHandler();

        window.addEventListener('click', (event) => {
            if (event.target.classList.contains('selected-product-remove') || event.target.closest('.selected-product-remove')) {
                // console.log('Clicked Remove Button: ', event.target);
                this.removeSelectedProducts(event.target.classList.contains('selected-product-remove') ? event.target : event.target.closest('.selected-product-remove'));
            }
        });
    }

    ctaButtonClickHandler() {
        this.add_to_cart_button.addEventListener('click', async () => {

            this.add_to_cart_button.classList.add('loading');
            this.add_to_cart_button.setAttribute('disabled', true);

            this.cart = await this.getCart();
            const body = {};
            this.selectedProducts.forEach(product => {
                const productId = product.getAttribute('data-product-id');
                const quantityInCart = this.cart.items.find(item => item.variant_id == productId)?.quantity || 0;
                // console.log(`Product ID: ${productId}, Quantity in Cart: ${quantityInCart}`);

                body[productId] = quantityInCart + 1; // Assuming quantity of 1 for each selected product
            });
            console.log('Adding to Cart: ', body);
            this.addOfferToCart(body);
        });
    }
    

    selectProducts() {
        this.all_offer_products.forEach(product => {
            product.addEventListener('click', () => {
                if (!product.classList.contains('disabled')) {

                    // console.log('Clicked Product: ', product);

                    const productImage = product.querySelector('img').src;
                    const productId = product.getAttribute('data-product-id');

                    this.selectedProducts.push(product);

                    this.single_selected_product_container[this.selectedProducts.length - 1].innerHTML = '';
                    this.single_selected_product_container[this.selectedProducts.length - 1].innerHTML = `
                        <img src="${productImage}" alt="Selected Product">
                        <span class="selected-product-remove" data-product-index="${this.selectedProducts.length - 1}" data-product-id="${productId}">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                        </span>
                    `;

                    // Handling CTA Button State
                    if (this.selectedProducts.length === 3) {
                        this.add_to_cart_button.classList.remove('disabled');
                        this.add_to_cart_button.innerHTML = `Add Offer To Cart`;
                        this.add_to_cart_button.removeAttribute('disabled');
                        
                        // Smooth scroll to Selector Button
                        const selectorContainer = document.querySelector('.selected-product-container-title');
                        const scrollTop = new SmoothScroll()
                        scrollTop.smoothScrollTo(selectorContainer, 700, 120);
                    }
                    else {
                        this.add_to_cart_button.innerHTML = `Choose ${3 - this.selectedProducts.length} more Products`;
                        this.add_to_cart_button.classList.add('disabled');
                        this.add_to_cart_button.setAttribute('disabled', true);
                    }

                    // Handling Price Calculation
                    const productPrice = parseFloat(product.getAttribute('data-product-price'))/100 || 0;
                    this.totalPrice.push(productPrice);
                    const priceSum = this.totalPrice.reduce((acc, curr) => acc + curr, 0);
                    const savings = priceSum - Math.max(...this.totalPrice);

                    this.priceContainer.innerHTML = `Estimated Total: ₹${Math.max(...this.totalPrice).toLocaleString()} <span class='offer-price'>₹${priceSum.toLocaleString()}</span> <span class='offer-saving'>Save ₹${savings.toLocaleString()}</span>`;

                    product.classList.add('disabled');

                    // console.log('Current Selected Products: ', this.selectedProducts);

                    // this.removeSelectedProducts();

                    // Make Moisturizer and Hand Cream Filter
                    console.log('Selected Product ID: ', productId);
                    if (productId === '42833543200920' || productId === '42833560567960' || productId === '42833581834392') {
                        this.disableMoisturizers();
                    } else if (productId === '42833568137368' || productId === '42833598054552' || productId === '42833589960856') {
                        this.disableHandCreams();
                    }


                    if(this.selectedProducts.length >= 3) {
                        this.disableAllProducts();
                        return;
                    }


                } else {
                    return;
                }
            });
        });
    }

    removeSelectedProducts(target) {
        const productId = parseInt(target.getAttribute('data-product-id'));
        const productToRemove = this.selectedProducts.find(product => product.getAttribute('data-product-id') === String(productId));

        if (productToRemove) {
            const productId = productToRemove.getAttribute('data-product-id');
            const correspondingProduct = Array.from(this.all_offer_products).find(product => product.getAttribute('data-product-id') === productId);

            if (correspondingProduct) {
                correspondingProduct.classList.remove('disabled');
            }

            // this.selectedProducts.splice(productIndex, 1);
            const productIndex = this.selectedProducts.findIndex(product => product.getAttribute('data-product-id') === String(productId));
            if (productIndex !== -1) {
                this.selectedProducts.splice(productIndex, 1);
            }
            target.parentElement.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"/>
            </svg>`;

            // Handling CTA Button State
            if (this.selectedProducts.length === 3) {
                this.add_to_cart_button.classList.remove('disabled');
                this.add_to_cart_button.removeAttribute('disabled');
                this.add_to_cart_button.innerHTML = `Add Offer To Cart`;
            }
            else {
                this.add_to_cart_button.innerHTML = `Choose ${3 - this.selectedProducts.length} more Products`;
                this.add_to_cart_button.classList.add('disabled');
                this.add_to_cart_button.setAttribute('disabled', true);
            }

            // Updating Price
            const productPrice = parseFloat(correspondingProduct.getAttribute('data-product-price'))/100 || 0;
            const priceIndex = this.totalPrice.indexOf(productPrice);

            if (priceIndex !== -1) {
                this.totalPrice.splice(priceIndex, 1);
            }
            const priceSum = this.totalPrice.reduce((acc, curr) => acc + curr, 0);
            const savings = priceSum - Math.max(...this.totalPrice);


            // Shift Selected Products
            this.shiftSelectedProducts();

            if (priceSum === 0) {
                this.priceContainer.innerHTML = '';
                this.enableAllProducts();
                return;
            }
            

            this.priceContainer.innerHTML = `Estimated Total: ₹${Math.max(...this.totalPrice).toLocaleString()} <span class='offer-price'>₹${priceSum.toLocaleString()}</span> <span class='offer-saving'>Save ₹${savings.toLocaleString()}</span>`;

            this.enableProducts();
            return;
        }

    }

    shiftSelectedProducts() {
        // First, clear all containers to remove any previous content
        this.single_selected_product_container.forEach(container => {
            container.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"/>
            </svg>`;
        });

        // Then, repopulate only the slots corresponding to selected products
        for (let i = 0; i < this.selectedProducts.length; i++) {
            const product = this.selectedProducts[i];
            const productImage = product.querySelector('img').src;
            const productId = product.getAttribute('data-product-id');

            this.single_selected_product_container[i].innerHTML = `
                <img src="${productImage}" alt="Selected Product">
                <span class="selected-product-remove" data-product-index="${i}" data-product-id="${productId}">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </span>
            `;
        }
    }

    disableAllProducts(){
        this.all_offer_products.forEach(product => {
            product.classList.add('disabled');
        });
    }

    disableProducts() {
        this.all_offer_products.forEach(product => {

            if(this.selectedProducts.length >= 3) {
                product.classList.add('disabled');
                return;
            }

            if (this.selectedProducts.length > 0) {
                const selectedProductIds = this.selectedProducts.map(product => product.getAttribute('data-product-id'));
                // console.log('Selected Product IDs: ', selectedProductIds);
                if (selectedProductIds.includes(product.getAttribute('data-product-id'))) {
                    product.classList.add('disabled');
                } else {
                    product.classList.remove('disabled');
                }
            }

            const productId = parseInt(product.getAttribute('data-product-id'));
            // const isInCart = this.cart.items.some(item => item.variant_id === productId);
            product.classList.remove('disabled');
            console.log('Checking Product ID: #######################');
            // if (isInCart) {
            //     product.classList.add('disabled');
            // }

        });
    }

    addOfferToCart(body) {

        const sections = this.miniCart ? this.miniCart.getSectionsToRender().map((section) => section.id) : [];

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            updates: body,
            sections: sections,
            sections_url: window.location.pathname
          })
        }).then((response) => response.json())
          .then((parsedState) => {

            console.log('Cart Updated: ', parsedState);

              this.miniCart && this.miniCart.renderContents(parsedState);

              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                detail: {
                  product: parsedState
                }
              }));
            
          })
          .catch((e) => {
            console.error(e);
            console.log("Response: ", response);
          }).finally(() => {
            this.resetSelectedProducts();
            this.add_to_cart_button.classList.remove('loading');
            this.add_to_cart_button.removeAttribute('disabled');
            this.newSetNotice.innerHTML = 'Make a new Set';
          });

    }

    enableProducts() {
        this.all_offer_products.forEach(product => {
            if (!this.selectedProducts.includes(product)) {
                product.classList.remove('disabled');
            }
        });

        this.selectedProducts.forEach(product => {
            const productId = parseInt(product.getAttribute('data-product-id'));
            if (productId === 42833543200920 || productId === 42833560567960 || productId === 42833581834392) {
                this.disableMoisturizers();
            } else if (productId === 42833568137368 || productId === 42833598054552 || productId === 42833589960856) {
                this.disableHandCreams();
            }
        });
    }

    enableAllProducts() {
        this.all_offer_products.forEach(product => {   
                product.classList.remove('disabled');     
        });
    }

    disableMoisturizers() {
        this.all_offer_products.forEach(product => {
            const productId = parseInt(product.getAttribute('data-product-id'));
            if (productId === 42833543200920 || productId === 42833560567960 || productId === 42833581834392) {
                product.classList.add('disabled');
            }
        });
    }

    disableHandCreams() {
        this.all_offer_products.forEach(product => {
            const productId = parseInt(product.getAttribute('data-product-id'));
            if (productId === 42833568137368 || productId === 42833598054552 || productId === 42833589960856) {
                product.classList.add('disabled');
            }
        });
    }

    resetSelectedProducts() {
        this.selectedProducts = [];
        this.single_selected_product_container.forEach(container => {
            container.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-plus" fill="none" viewBox="0 0 10 10">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1 4.51a.5.5 0 000 1h3.5l.01 3.5a.5.5 0 001-.01V5.5l3.5-.01a.5.5 0 00-.01-1H5.5L5.49.99a.5.5 0 00-1 .01v3.5l-3.5.01H1z" fill="currentColor"/>
            </svg>`;
        });
        this.priceContainer.innerHTML = '';
        this.enableAllProducts();
        this.add_to_cart_button.classList.add('disabled');
        this.add_to_cart_button.setAttribute('disabled', true);
        this.add_to_cart_button.innerHTML = `Choose 3 Products`;
        this.totalPrice = [];
    }

    async getCart() {
        const res = await fetch('/cart.js');
        return res.json();
    }

    // smoothScrollTo(target, options = {}) {
    //     const {
    //         behavior = 'smooth',
    //         block = 'start',
    //         inline = 'nearest'
    //     } = options;

    //     const element =
    //         typeof target === 'string' ? document.querySelector(target) : target;

    //     if (!element) {
    //         console.warn('smoothScrollTo: target not found', target);
    //         return;
    //     }

    //     element.scrollIntoView({
    //         behavior,
    //         block,
    //         inline
    //     });
    // }
    
}

document.addEventListener("DOMContentLoaded", function() {
    new B1G2Offer().init();
});

